<div>
  <video controls [src]="data.url" width="900"></video>
</div>
